import { Close, Delete, School } from '@mui/icons-material';
import {
  Autocomplete,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  Modal,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { Col, Row, message } from 'antd';
import { DeleteModal } from 'components/Dialog';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { get } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { makeStyles } from '@mui/styles';
import MultiImageUploader from './multiImageUploader';
import BadgeButton from 'components/AdminBooks/BadgeButton';
import SentryWrap from 'components/Sentry';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
  rootDifFull: {
    width: '100%',
  },
  label: {
    textTransform: 'uppercase',
  },
  sizeSmall: {
    width: '55px',
    height: '25px',
  },
  checkedSwitch: {
    transform: 'translateX(30px) !important',
  },
}));

const TeacherEditionModal = ({
  pageId,
  onRemove,
  data,
  onChangeDesc,
  onChangeImage,
  title,
  booksAllList,
  hasPermission = true
}) => {
  const classes = useStyles();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedType, setSelectedType] = useState('uploader');
  const [selectedBook, setSelectedBook] = useState(null);
  const [selectedBookData, setSelectedBookData] = useState(null);
  const [imageData, setImageData] = useState([]);
  const [teacherEditionPageDrawer, setTeacherEditionPageDrawer] = useState(false);
  const showAlert = useAlert();
  const toPageInputRef = useRef(null);

  useEffect(() => {
    if (data && teacherEditionPageDrawer) {
      setSelectedBookData(data?.edBookData || null);
      setSelectedType(data?.selectedType || 'uploader');
      setSelectedBook(booksAllList.find((bk) => bk.id === data?.edBookData?.bookId) || null);
      let imageArray = [];
      if (data && data?.resource && !data?.imageData?.includes(data?.resource)) {
        const imageResource = {
          sequence: 1,
          resource: data?.resource,
        };
        imageArray.push(imageResource);
      }
      if (data?.imageData && Array.isArray(data?.imageData)) {
        setImageData([...imageArray, ...data?.imageData] || []);
      } else {
        setImageData([...imageArray]);
      }
    }else{
      setImageData([]);
      setSelectedBookData(null);
      setSelectedBook(null);
      setDeleteModal(false);
    }
  }, [data, booksAllList, teacherEditionPageDrawer]);


  const generatePageOptions = () => {
    return selectedBook?.pages || [];
  };

  const getPageIndex = (pages, value) => {
    if (!Array.isArray(pages) || pages.length === 0 || !value) return -1;
    return pages.findIndex((page) => String(page.pageId) === String(value));
  };

  const generateToPageOptions = () => {
    const pages = generatePageOptions();
    const from = get(selectedBookData, 'from');
    if (!from || !Array.isArray(pages) || pages.length === 0) return [];
    const fromIndex = getPageIndex(pages, from);
    if (fromIndex === -1) return [];
    return pages.slice(fromIndex + 1);
  };
  const handleSubmit = () => {
    try {
      if (selectedType === 'book') {
        if (!selectedBookData?.from) {
          return showAlert('Please select from page', 'error');
        } else if (!selectedBookData?.to) {
          return showAlert('Please select to page', 'error');
        } else if (!selectedBookData?.bookId) {
          return showAlert('Please select book', 'error');
        } else if (Array.isArray(selectedBook?.pages)) {
          const fromIndex = getPageIndex(selectedBook.pages, selectedBookData?.from);
          const toIndex = getPageIndex(selectedBook.pages, selectedBookData?.to);

          if (fromIndex === -1 || toIndex === -1) {
            return showAlert('Please select valid pages.', 'error');
          }
          if (fromIndex >= toIndex) {
            return showAlert('From page must be less than To page', 'error');
          }
          if (toIndex - fromIndex > 10) {
            return showAlert('Difference between From and To page cannot be greater than 10', 'error');
          }
        } else {
          return showAlert('Please select valid pages.', 'error');
        }
      }
      const data = {
        from: selectedBookData?.from,
        to: selectedBookData?.to,
        bookId: selectedBookData?.bookId,
      };

      onChangeDesc(data, selectedType, pageId);
      setTeacherEditionPageDrawer(false);
    } catch (err) {
      console.error('TeacherEditionModal submit error', err);
    }
  };

  const handleClose = () => {
    setTeacherEditionPageDrawer(false);
    setImageData([]);
    setDeleteModal(false);
    setSelectedBook(null);
    setSelectedBookData(null);
  };

  const handlerOnChange = (data) => {
    onChangeImage(data, selectedType);
    handleClose();
  };


  return (
    <SentryWrap>
      <BadgeButton
        onClick={() => {
          if (!hasPermission) {
            message.warning('You do not have permission to access this feature.');
            return;
          }
          setTeacherEditionPageDrawer(true);
        }}
        startIcon={<School />}
        showBadge={data}
        backgroundColor="#ea580c"
      >
        Teacher edition
      </BadgeButton>
      <DeleteModal
        deleteToggle={deleteModal}
        onDelete={() => {
          onRemove(data);
          handleClose();
        }}
        setDeleteToggle={setDeleteModal}
        message={`Are you sure you want to remove "${title}" on pageId ${pageId}?`}
      />

      <Modal
        open={teacherEditionPageDrawer}
        onClose={() => handleClose()}
        style={{ height: '100%', width: '100%' }}
      >
        <ModalContent style={{ width: '60vw', maxWidth: '500px' }}>
          <Row style={{ justifyContent: 'space-between' }}>
            <TitleText>{title}</TitleText>
            <IconButton onClick={() => handleClose()} style={{ padding: 0, marginRight: 10 }}>
              <Close color="secondary" />
            </IconButton>
          </Row>
          <ModalConfigArea>
            <FormControl>
              <RadioGroup
                row
                required
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={selectedType}
                onChange={(e) => {
                  setSelectedType(e.target.value);
                }}
                sx={{ columnGap: 2 }}
              >
                <FormControlLabel
                  control={<Radio sx={{ color: 'red', '&.Mui-checked': { color: 'red' } }} />}
                  value="book"
                  label="Select from Book"
                />
                <FormControlLabel
                  control={<Radio sx={{ color: 'red', '&.Mui-checked': { color: 'red' } }} />}
                  value="uploader"
                  label="Select from Uploader"
                />
              </RadioGroup>
            </FormControl>
            <div className="flex w-full justify-end mt-10px mb-10px">
              {data ? (
                <IconButton
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                  style={{ padding: 0 }}
                >
                  <Delete color="secondary" />
                </IconButton>
              ) : null}
            </div>
            {selectedType === 'book' ? (
              <>
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="bookId">Book</InputLabel>
                  <Autocomplete
                    id="bookId"
                    options={booksAllList?.filter((bk) => bk.active)}
                    getOptionLabel={(option) => `${option.description || ''} (${option.id || ''})`}
                    value={selectedBook}
                    onChange={(event, newValue) => {
                      setSelectedBook(newValue);
                      setSelectedBookData((prev) => ({ ...prev, bookId: newValue?.id }));
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Book" variant="outlined" />
                    )}
                  />
                </FormControl>
                {selectedBook?.pages && (
                  <>
                    <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                      <Col span={24}>
                        <Autocomplete
                          id="from-page-autocomplete"
                          options={generatePageOptions()}
                          getOptionLabel={(option) => option.NumberMasked || option.pageId || ''}
                          value={generatePageOptions().find(page => page.pageId == get(selectedBookData, 'from')) || null}
                          onChange={(event, newValue) => {
                            setSelectedBookData((prev) => ({
                              ...prev,
                              from: newValue?.pageId || '',
                              to: '',
                            }));
                            window.setTimeout(() => {
                              if (toPageInputRef.current && typeof toPageInputRef.current.focus === 'function') {
                                toPageInputRef.current.focus();
                              }
                            }, 0);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="from Page"
                              variant="outlined"
                              fullWidth
                              className="floatlabelCstm"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                              }}
                            />
                          )}
                          renderOption={(props, option) => <li {...props}>{option.NumberMasked || option.pageId}</li>}
                          freeSolo={false}
                          clearOnEscape
                          selectOnFocus
                          handleHomeEndKeys
                        />
                      </Col>
                    </Row>

                    <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                      <Col span={24}>
                        <Autocomplete
                          id="to-page-autocomplete"
                          options={generateToPageOptions()}
                          getOptionLabel={(option) => option.NumberMasked || option.pageId || ''}
                          value={generatePageOptions().find(page => page.pageId == get(selectedBookData, 'to')) || null}
                          onChange={(event, newValue) => {
                            setSelectedBookData((prev) => ({
                              ...prev,
                              to: newValue?.pageId || '',
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="to Page"
                              variant="outlined"
                              fullWidth
                              className="floatlabelCstm"
                              inputRef={toPageInputRef}
                              slotProps={{
                                htmlInput: {
                                  ...params.inputProps,
                                  placeholder: !get(selectedBookData, 'from')
                                    ? "Please select 'From Page' first"
                                    : 'Select ending page',
                                },
                                inputLabel: {
                                  shrink: true,
                                },
                              }}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                              }}
                            />
                          )}
                          renderOption={(props, option) => <li {...props}>{option.NumberMasked || option.pageId}</li>}
                          freeSolo={false}
                          clearOnEscape
                          selectOnFocus
                          handleHomeEndKeys
                          disabled={!get(selectedBookData, 'from')}
                        />
                      </Col>
                    </Row>
                  </>
                )}

                <Button
                  color="primary"
                  variant="contained"
                  sx={{ marginTop: '10px', float: 'right' }}
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </>
            ) : selectedType === 'uploader' ? (
              <MultiImageUploader
                onChange={handlerOnChange}
                pageId={pageId}
                onChangeDescription={onChangeDesc}
                hasDescription={false}
                imageData={imageData}
                setImageData={setImageData}
                selectedType={selectedType}
              />
            ) : null}
          </ModalConfigArea>
        </ModalContent>
      </Modal>
    </SentryWrap>
  );
};

export default TeacherEditionModal;

const ModalContent = styled.div`
  left: 50%;
  max-width: 100vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
`;
